/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: ea99bacb (Fri Jun  5 23:34:18 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import { ProgramType } from './'

/**
 *
 * @export
 * @interface EnrollmentInvoiceStubEnrollments
 */
export interface EnrollmentInvoiceStubEnrollments {
  /**
   *
   * @type number
   * @memberof EnrollmentInvoiceStubEnrollments
   */
  programKey: number
  /**
   *
   * @type number
   * @memberof EnrollmentInvoiceStubEnrollments
   */
  studentKey: number
  /**
   *
   * @type string
   * @memberof EnrollmentInvoiceStubEnrollments
   */
  firstName: string
  /**
   *
   * @type ProgramType
   * @memberof EnrollmentInvoiceStubEnrollments
   */
  program: ProgramType
  /**
   *
   * @type Date
   * @memberof EnrollmentInvoiceStubEnrollments
   */
  semesterOneStartDate?: Date
}

export function EnrollmentInvoiceStubEnrollmentsFromJSON(
  json: any
): EnrollmentInvoiceStubEnrollments {
  return EnrollmentInvoiceStubEnrollmentsFromJSONTyped(json, false)
}

export function EnrollmentInvoiceStubEnrollmentsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): EnrollmentInvoiceStubEnrollments {
  if (json === undefined || json === null) {
    return json
  }
  return {
    programKey: json['programKey'],
    studentKey: json['studentKey'],
    firstName: json['firstName'],
    program: json['program'],
    semesterOneStartDate: !exists(json, 'semesterOneStartDate')
      ? undefined
      : new Date(json['semesterOneStartDate']),
  }
}

export function EnrollmentInvoiceStubEnrollmentsToJSON(
  value?: EnrollmentInvoiceStubEnrollments | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    programKey: value.programKey,
    studentKey: value.studentKey,
    firstName: value.firstName,
    program: value.program,
    semesterOneStartDate:
      value.semesterOneStartDate === undefined
        ? undefined
        : value.semesterOneStartDate.toISOString().substr(0, 10),
  }
}
